module.exports = "../../app/cells/components/modals/setup_wizard/objective.erb";